"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.parseUTMs = void 0;
const helpers_1 = require("../helpers");
const UTM_SOURCE = "utm_source";
const UTM_CAMPAIGN = "utm_campaign";
const UTM_MEDIUM = "utm_medium";
const re_utm_source = new RegExp("utm_source=([^&]+)");
const re_utm_medium = new RegExp("utm_medium=([^&]+)");
const re_utm_campaign = new RegExp("utm_campaign=([^&]+)");
const parseUTMs = () => {
    var _a, _b, _c, _d, _e, _f, _g, _h, _j, _k, _l, _m, _o, _p, _q;
    if (!(0, helpers_1.isBrowser)())
        return;
    const cookies = (0, helpers_1.parseCookies)();
    const { search, hash } = window.location;
    let utm_source = (_e = (_d = (_b = (_a = search.match(re_utm_source)) === null || _a === void 0 ? void 0 : _a[1]) !== null && _b !== void 0 ? _b : (_c = hash.match(re_utm_source)) === null || _c === void 0 ? void 0 : _c[1]) !== null && _d !== void 0 ? _d : cookies[UTM_SOURCE]) !== null && _e !== void 0 ? _e : "organic";
    let utm_medium = (_k = (_j = (_g = (_f = search.match(re_utm_medium)) === null || _f === void 0 ? void 0 : _f[1]) !== null && _g !== void 0 ? _g : (_h = hash.match(re_utm_medium)) === null || _h === void 0 ? void 0 : _h[1]) !== null && _j !== void 0 ? _j : cookies[UTM_MEDIUM]) !== null && _k !== void 0 ? _k : "native";
    let utm_campaign = (_q = (_p = (_m = (_l = search.match(re_utm_campaign)) === null || _l === void 0 ? void 0 : _l[1]) !== null && _m !== void 0 ? _m : (_o = hash.match(re_utm_campaign)) === null || _o === void 0 ? void 0 : _o[1]) !== null && _p !== void 0 ? _p : cookies[UTM_CAMPAIGN]) !== null && _q !== void 0 ? _q : "empty";
    if (utm_source) {
        (0, helpers_1.setCookie)(UTM_SOURCE, utm_source);
    }
    if (utm_medium) {
        (0, helpers_1.setCookie)(UTM_MEDIUM, utm_medium);
    }
    if (utm_campaign) {
        (0, helpers_1.setCookie)(UTM_CAMPAIGN, utm_campaign);
    }
    return { utm_medium, utm_source, utm_campaign };
};
exports.parseUTMs = parseUTMs;
